import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';
import ShopaholicCartPosition from '@lovata/shopaholic-cart/shopaholic-cart-position';
import ProductCardHelper from '../../common/helper/product-card-helper';
import RemoveCardHelper from '../../common/helper/remove-card-helper';

export default new class ProductCardQuickAdd {
  constructor() {
    this.obShopaholicCartAdd = new ShopaholicCartAdd();
    this.obShopaholicCartRemove = new RemoveCardHelper();
    this.productCardHelper = new ProductCardHelper();

    this.productCardFooterPreloader = 'product-card-footer__preloader';

    // Modal windows
    this.drawerNavSelector = 'quick-add__wrapper';
    this.drawerBtnSelector = 'js-add-cart-modal';
    this.drawerOpenNavSelector = 'quick-add__wrapper_visible';
    this.drawerProductPanel = 'quick-add-product__panel';
    this.isLoad = false;

    // Form add cart
    this.formClass = 'quick-add__form';
    this.idProductSelector = 'data-product-id';
    this.sMiniCartWrapper = '_shopaholic-cart-mini-wrapper';
    this.addCartBtnSelector = '_shopaholic-cart-add';
    this.quantityBtn = '_quantity-btn';

    this.productFooterWrapper = 'product-card__footer';
    this.productDataIDSelector = 'data-product-id';
    this.offerDataIDSelector = 'data-offer-id';

    // Select offer list
    this.productCartPriceWrapper = 'product-card__price-wrap';
    this.offerSelectClass = 'filter-size__checkbox';

    this.addCartPreloader = 'add-cart__preloader';

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      // this.initCartFooter();
    });
    this.initOfferSelect();
    this.updateQuantity();
    this.initAddCart();
    this.initRemoveOffer();
  }

  initCartFooter() {
    $.request('CartHelper::onGetCartPositions', {
      complete: ({ responseJSON }) => {
        const arPositions = responseJSON.data;
        this.updateCartFooter(arPositions);
      },
    });
  }

  updateCartFooter(arPositions) {
    const arProductsCard = document.querySelectorAll(`.${this.productFooterWrapper}`);
    arProductsCard.forEach((el) => {
      const productId = el.getAttribute(this.productDataIDSelector);
      if (!productId) {
        return;
      }
      const offerId = el.getAttribute(this.offerDataIDSelector);
      if (!offerId) {
        return;
      }
      let noCart = false;
      if (arPositions) {
        noCart = true;
      }
      $.request('onAjax', {
        data: {
          product_id: productId,
          offer_id: offerId,
          no_cart: noCart,
          ar_positions: arPositions,
        },
        loading: `.${this.productCardFooterPreloader}-${productId}`,
        update: {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          'product/product-card/product-card-footer': `.${this.productFooterWrapper}-${productId}`,
        },
      });
    });
  }

  initAddCart() {
    $('body')
      .on('click', `.${this.addCartBtnSelector}`, (e) => {
        const productId = e.currentTarget.getAttribute(this.productDataIDSelector);
        const offerId = e.currentTarget.getAttribute(this.offerDataIDSelector);
        this.obShopaholicCartAdd.setAjaxRequestCallback((obRequestData, obButton) => {
          /* eslint-disable  no-param-reassign */
          obRequestData.update = { 'product/cart/cart-mini/cart-info/cart-info': `.${this.sMiniCartWrapper}` };
          obRequestData.loading = `${this.addCartPreloader}-${productId}`;
          obRequestData.complete = ({ responseJSON }) => {
            this.obShopaholicCartAdd.completeCallback(responseJSON, obButton);
            this.updateProductCardBtnWrapper(productId, offerId);
          };
          /* eslint-enable */

          return obRequestData;
        })
          .init();
      });
  }

  initOfferSelect() {
    $('body')
      .on('click', `.${this.offerSelectClass}`, ({ target }) => {
        const productId = target.getAttribute(this.productDataIDSelector);
        const offerId = target.value;

        if (!productId) {
          return;
        }

        if (!offerId) {
          return;
        }

        $.request('onAjax', {
          data: {
            product_id: productId,
            offer_id: offerId,
          },
          loading: `.${this.addCartPreloader}-${productId}`,
          update: {
            'product/product-card/product-card-price': `.${this.productCartPriceWrapper}-${productId}`,
            'product/product-card/product-card-footer': `.${this.productFooterWrapper}-${productId}`,
          },
        });
      });
  }

  updateProductCardBtnWrapper(productId, offerId) {
    $.request('onAjax', {
      data: {
        product_id: productId,
        offer_id: offerId,
      },
      loading: `.${this.addCartPreloader}-${productId}`,
      update: {
        'product/product-card/product-card-footer': `.${this.productFooterWrapper}-${productId}`,
      },
      complete: () => {
      },
    });
  }

  initRemoveOffer() {
    this.obShopaholicCartRemove.setAjaxRequestCallback((obRequestData, obButton) => {
      const productId = obButton.getAttribute(this.productDataIDSelector);
      const offerId = obButton.getAttribute(this.offerDataIDSelector);
      const obCartPosition = new ShopaholicCartPosition(obButton);
      const iPositionID = obCartPosition.getPositionID();
      /* eslint-disable  no-param-reassign */
      obRequestData.data = {
        product_id: productId,
        offer_id: offerId,
        cart: [iPositionID],
        type: 'position',
      };
      obRequestData.update = { 'product/cart/cart-mini/cart-info/cart-info': `.${this.sMiniCartWrapper}` };
      obRequestData.update['product/product-card/product-card-footer'] = `.${this.productFooterWrapper}-${productId}`;
      /* eslint-enable */
      return obRequestData;
    }).setRemoveSelector('_product-cart-card-remove').init();
  }

  updateQuantity() {
    this.productCardHelper.initUpdateQuantity();
    this.productCardHelper.setRemoveSelector('_product-cart-card-remove').setQuantitySelector('_quantity-card').init();
  }
}();
